var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":false,"light":false,"id":"inspire"}},[_c('Snackbar'),_c('div',{staticClass:"aa-main"},[_c('Header'),_vm._t("default")],2),_c('aa-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }